export const GET_AMERICAN_STATES="pay-citation/GET_AMERICAN_STATES";
export const SET_AMERICAN_STATES="pay-citation/SET_AMERICAN_STATES";
export const SET_TOKEN="pay-citation/SET_TOKEN";

export const getAmericanStates=()=>{
    return{
        type:GET_AMERICAN_STATES
    }
}
export const setAmericanStates=(data)=>{
    return{
        type:SET_AMERICAN_STATES,
        payload:data
    }
}

export const setToken = (data) =>{
    return{
        type:SET_TOKEN,
        payload:data
    }
}